import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import moment from "moment";

import { useStyles } from "./UserTimetable.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../Config/Config";
import { formatTime } from "../../../Components/FormatTime/FormatTime";
import UserTeacherTimetable from "./UserTeacherTimetable/UserTeacherTimetable";
import { week } from "../../../Components/Data/Weeks";
import CustomSiteLoader from "../../../Components/CustomSiteLoader/CustomSiteLoader";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class UserTimetable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeTables: [],
      times: [],
      day: week[moment(new Date()).day()],
    };
  }

  componentDidMount() {
    this.getUserTimetable();
  }

  getUserTimetable = async () => {
    try {
      if (this.props.role === "Teacher") {
        const response = await Axios.get(`${url}/api/time-tables`, {
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        let timeData = [];
        for (let i = 0; i <= response.data.timeTables.length - 1; i++) {
          for (
            let j = 0;
            j <= response.data.timeTables[i].times.length - 1;
            j++
          ) {
            for (
              let k = 0;
              k <= response.data.timeTables[i].times[j].subjects.length - 1;
              k++
            ) {
              if (
                response.data.timeTables[i].times[j].subjects[k]
                  .classTeacherId === this.props.userId
              ) {
                response.data.timeTables[i].faculty &&
                response.data.timeTables[i].group
                  ? timeData.push({
                      studentClass: response.data.timeTables[i].studentClass,
                      faculty: response.data.timeTables[i].faculty,
                      group: response.data.timeTables[i].group,
                      section: response.data.timeTables[i].section,
                      weekName: response.data.timeTables[i].times[j].weekName,
                      subjectName:
                        response.data.timeTables[i].times[j].subjects[k]
                          .subjectName,
                      from: response.data.timeTables[i].times[j].subjects[k]
                        .from,
                      to: response.data.timeTables[i].times[j].subjects[k].to,
                      classTeacherName:
                        response.data.timeTables[i].times[j].subjects[k]
                          .classTeacherName,
                    })
                  : timeData.push({
                      studentClass: response.data.timeTables[i].studentClass,
                      section: response.data.timeTables[i].section,
                      weekName: response.data.timeTables[i].times[j].weekName,
                      subjectName:
                        response.data.timeTables[i].times[j].subjects[k]
                          .subjectName,
                      from: response.data.timeTables[i].times[j].subjects[k]
                        .from,
                      to: response.data.timeTables[i].times[j].subjects[k].to,
                      classTeacherName:
                        response.data.timeTables[i].times[j].subjects[k]
                          .classTeacherName,
                    });
              }
            }
          }
        }
        if (timeData.length !== 0) {
          this.setState({
            times: timeData,
            isEmpty: false,
          });
        } else {
          this.setState({
            times: [],
            isEmpty: true,
          });
        }
      } else {
        const responseStudent = await Axios.get(
          `${url}/api/students/${this.props.userId}`,
          {
            headers: { Authorization: `Bearer ${this.props.userToken}` },
          }
        );
        const response = await Axios.get(`${url}/api/time-tables`, {
          params: {
            studentClass: responseStudent.data.student.studentClass,
            faculty: responseStudent.data.student.faculty
              ? responseStudent.data.student.faculty
              : "",
            group: responseStudent.data.student.group
              ? responseStudent.data.student.group
              : "",
            section: responseStudent.data.student.section,
          },
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        if (response.data.timeTables.length !== 0) {
          this.setState({
            timeTables: response.data.timeTables[0],
            times: response.data.timeTables[0].times,
            isEmpty: false,
          });
        } else {
          this.setState({
            timeTables: [],
            times: [],
            isEmpty: true,
          });
        }
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserTimetable();
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { timeTables, times } = this.state;
    let weekFilter = times.find((data) => data.weekName === this.state.day);
    let weekEmpty = weekFilter ? false : true;
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.sectionDesktop}>
            <PageTitle title="TimeTable" refreshUrl={this.props.match.url} />
          </div>
          <div>
            {this.props.role === "Teacher" ? (
              <UserTeacherTimetable times={this.state.times} />
            ) : (
              <div>
                <div className={classes.sectionDesktop}>
                  {timeTables.studentClass}
                  {timeTables.section}
                  {times.map((week, index) => (
                    <List key={index} style={{ display: "flex" }}>
                      <ListItem
                        divider
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: 0,
                        }}
                      >
                        {week.weekName}
                      </ListItem>
                      {week.subjects.map((subject, subjIndex) => (
                        <ListItem
                          divider
                          key={subjIndex}
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div>{subject.subjectName}</div>{" "}
                          {subject.from && subject.to ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              ({formatTime(subject.from)} -{" "}
                              {formatTime(subject.to)})
                            </div>
                          ) : (
                            <div>N/A</div>
                          )}
                          <b>{subject.classTeacherName}</b>
                        </ListItem>
                      ))}
                    </List>
                  ))}
                </div>

                <div className={classes.sectionMobile}>
                  <TextField
                    name="day"
                    select
                    required
                    fullWidth
                    label="Day"
                    variant="outlined"
                    margin="normal"
                    SelectProps={{ native: true }}
                    style={{ marginRight: 10 }}
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline,
                        focused: classes.focused,
                      },
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.labelRoot,
                        focused: classes.labelFocused,
                      },
                      shrink: true,
                    }}
                    value={this.state.day}
                    onChange={(e) => this.setState({ day: e.target.value })}
                  >
                    <option value="">Select Any One</option>
                    {week.map((week, index) => (
                      <option value={week} key={index}>
                        {week}
                      </option>
                    ))}
                    <option value="Saturday">Saturday</option>
                  </TextField>
                  Current Day:{this.state.day}
                  {weekFilter ? (
                    <div>
                      {weekFilter.subjects.map((subject, index) => (
                        <div key={index}>
                          <Paper className={classes.paper}>
                            <div>{subject.subjectName}</div>
                            {subject.from && subject.to ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {formatTime(subject.from)} -{" "}
                                {formatTime(subject.to)}
                              </div>
                            ) : (
                              <div>N/A</div>
                            )}
                            <b>{subject.classTeacherName}</b>
                          </Paper>
                          <br />
                        </div>
                      ))}
                    </div>
                  ) : weekEmpty ? (
                    <div>Today's Saturday. Have lots of fun</div>
                  ) : (
                    <CustomSiteLoader />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserTimetable));
